import { Injectable } from '@angular/core';

import { FeatureFlag } from '@models/feature-flag.model';

import { INVESTIGATOR_ROUTES_FEATURE_FLAGS } from '@shared/constants/feature-flags-guards/investigator-feature-flags.const';
import { ROUTING_PATH } from '@shared/constants/routingPath';
import { BasicRedirectToNextTabGuard } from '@shared/guards/basic-redirect-to-next-tab.guard';
import { Flags } from '@shared/services/launch-darkly.service';

@Injectable({
  providedIn: 'root',
})
export class InvestigatorSummaryGuard extends BasicRedirectToNextTabGuard {
  protected defaultNavigateUrl = `/${ROUTING_PATH.TRIAL_INSIGHTS.INDEX}`;
  protected featureFlag = FeatureFlag.INVESTIGATOR_SUMMARY as keyof Flags;
  protected prefix = `/${ROUTING_PATH.INVESTIGATOR.INDEX}`;
  protected routerPathsAndFeatureFlags = INVESTIGATOR_ROUTES_FEATURE_FLAGS;
}
